


export class DetailsTableDialog {

    data: any[];
    dataTable: any;

    constructor(columns: any[], ordering: any[]) {

        $(() => {

            this.dataTable = $('#view-detail-table-modal-table').DataTable({
                autoWidth: true,
                info: false,
                paging: false,
                searching: false,
                //scrollX: true,
                scrollY: '70vh',
                scrollCollapse: true,
                orderCellsTop: true,
                columns: columns,
                order: ordering
            });

            $('#view-detail-table-modal').on('shown.bs.modal', () => {

                //this.dataTable.clear();
                $('#view-detail-table-modal-table').show();
                this.dataTable.draw();
                //this.dataTable.rows.add(this.data).draw();
            });

            $('#view-detail-table-modal').on('hide.bs.modal', () => {
                this.dataTable.clear();
                //this.dataTable.draw();
                $('#view-detail-table-modal-table').hide();
            });

        });


    }

    setData(data: any[]): void {

        //console.log("Set Data", data);
        this.data = data;
        this.dataTable.rows.add(this.data);
    }

    show(title: string = ""): void {
        $('#view-detail-table-modal-title').html(title);
        $('#view-detail-table-modal').modal('show');
    }
}
